import {INTQuestion} from '../NTQuestion';

export interface ICallSummary {
  QandAs: IQandA[];
  summary: ISummary;
  callDetail: IQandA[];
  notes?: string;
}

export interface IQandA {
  fieldLabel: any;
  question: INTQuestion;
  answer: string;
}

export const SUMMARY_FORMAT_HTML = 'html';

export interface ISummary {
  highlights: IHighlight[];
  format?: typeof SUMMARY_FORMAT_HTML;
}

export interface IHighlight {
  title: string;
  value: string;
}
